export default function () {

  const widgetName = 'tier2Slideshow';
  const widgetOpts = tier2SlideshowOpts;

  const swiperContainers = `
        <div class="swiper-container swiper-container-content">
              <div class="swiper-wrapper"></div>
        </div>
        <div class="swiper-pagination"></div>
  `;

  // Slide Template - Content
  function buildSlideTemplateContent(slide, i) {

    const numberslide = i+1;
    const title = `<span class="slide-title">${numberslide}.</span>`;
    const description = `<span class="slide-description">${slide.Description}</span>`;
    

    const template = `
      <div class="swiper-slide">
      ${slide.URL === null ? `<span class="card-slider">` : `<a href="${slide.URL}" title="Read More >" class="card-slider">`}
          <div class="swiper-content-container">
          <span></span>
                <div class="slider-content">
                    <div class="title-container">
                      ${title}
                      ${description}
                    </div>
                </div>
          </div>
          ${slide.URL === null ? `</span>` : `</a>`}
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetContentWrapper = $(`#${widgetName} .swiper-container-content .swiper-wrapper`);

    widgetData.forEach(function (slide, i) {
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide, i));
    });


    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      a11y: true,
      autoHeight: true,
      slidesPerView: 3,
      spaceBetween: 50,

      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true
      },
    });

  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);

    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
